module.exports = __webpack_public_path__ + "static/media/supplier-is-homologated.936f088f.svg";